import httpClient from '@/http-client'

export const get = (Options = {}) => {
    return httpClient
        .get('/api/v1/setup-news', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/v1/setup-news', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const find = id => {
    return httpClient
        .get(`/api/v1/setup-news/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/v1/setup-news/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const newsCategory = (Option = {}) => {
    return httpClient
        .get('/api/v1/setup-news/news-categories', Option)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const uploadfile = data => {
    return httpClient
        .post('/api/v1/setup-news/upload-image', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const readImage = id => {
    return httpClient
        .get(`/api/v1/setup-news/${id}/feature-image`, {
            responseType: 'arraybuffer'
        })
        .then(response =>
            Promise.resolve(
                `data:image/jpg;base64,${new Buffer(response.data, 'binary').toString(
                    'base64'
                )}`
            )
        )
        .catch(error => Promise.reject(error.response.data))
}

export const newImageContent = data => {
    return httpClient
        .post('/api/v1/setup-news/image-contents', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/v1/setup-news/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    get,
    find,
    store,
    update,
    uploadfile,
    newImageContent,
    readImage,
    newsCategory,
    destroy
}
